// extracted by mini-css-extract-plugin
export default {"discount":"DiscountSignal-module__discount___2_D5S"};